<template lang="pug">
  #establishments
    facet-list(
      :metrics="metrics"
      @change="facetChangeHandler"
    )
    .search-bar
      input(
        type="text" ref="searchBar"
        placeholder="Nom établissement / Nom fiche / ID fiche"
        @input="searchInputHandler"
      )
      i.material-icons search
    establishment-list(
      :establishments="establishments"
      :loading="loading"
      @scrollEnd="nextPage"
      @goToEstablishment="goToEstablishment"
    )
</template>

<script>
import FacetList from '@/views/establishments/FacetList.vue';
import EstablishmentList from '@/components/establishment-list/EstablishmentList.vue';
import establishmentService from '@/services/establishments.js';
import rcDebounce from '@/mixins/rcDebounce.js';

import { TEST_METRICS, TEST_SELECTIONS } from './../../tests/mocks/facets.js';

export default {
  mixins: [rcDebounce],
  components: {
    FacetList,
    EstablishmentList,
  },
  data() {
    return {
      establishments: [],
      count: 0,
      SEARCH_DEBOUNCE: 1000,
      loading: false,
      metrics: {},
      page: 0,
    };
  },
  mounted () {
    this.getEstablishments();
  },
  methods: {
    nextPage() {
      if (this.establishments.length < this.count) {
        this.page++;
        this.getEstablishments();
      }
    },
    async getEstablishments(search = '', selections = []) {
      this.loading = true;
      const response = await establishmentService.get({ search, selections, page: this.page });
      this.establishments = this.page ? [...this.establishments, ...response.elements] : response.elements;
      if (this.page === 0) {
        this.count = response.stats.total;
        this.metrics = response.stats;
      }
      this.loading = false;
    },
    facetChangeHandler(selections) {
      this.$el.scrollIntoView();
      this.page = 0;
      this.getEstablishments('', selections);
    },
    goToEstablishment({ establishmentId }) {
      this.$router.push(`/establishment/${establishmentId}`);
    },
    searchInputHandler(e) {
      this.rcDebounce(() => { this.getEstablishments(e.target.value) }, this.SEARCH_DEBOUNCE);
    },
  },
}
</script>

<style lang="scss">
  #establishments {
    padding: 2em 24px 2em 408px;
    #facet-list {
      position: fixed;
      left: 0;
      top: 0;
      height: 100%;
      padding: 1em 2em;
      z-index: 1;
      background: #CACACA;
      width: 24em;
      box-sizing: border-box;
    }
    .establishment-list {
      &.empty,.load-content {
        min-height: 20em;
      }
    }
    .search-bar {
      border-bottom: 1px solid #BABABA;
      width: 320px;
      display: flex;
      color: #BABABA;
      margin-bottom: 1em;
      input {
        &::placeholder {
          color: #BABABA;
        }
        outline: none;
        font-size: 16px;
        border: none;
        width: 100%;
      }
    }
  }
</style>